// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingInfoStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

shippingInfoStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

shippingInfoStyles.headingText = {
    variant: "h4",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

shippingInfoStyles.shippingAddressesWrapper = {
    css: css`
        display: flex;
        gap: 135px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 24px;
        }
    `,
};

shippingInfoStyles.addressSection = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 300px;
        ${xScreen("lte", "md")} {
            max-width: unset;
            width: unset;
            flex: 1;
        }
    `,
};

shippingInfoStyles.addressTitle = {
    variant: "h6",
    as: "p",
    css: css`
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid ${color("common.ui3")};
    `,
};
